module.exports = __webpack_public_path__ + "static/media/iconfinder_b-91_4230288.7d3ea596.svg";